import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';
import Button from '@mui/material/Button';

import { layoutInformation } from '../../submodules/xbox/utils/Layout';

import { safeArea } from '@egr/xbox/egr-gui-elements/Helper/StyleHelper';
import { android, ios, isMobileDevice } from '@egr/xbox/utils/UserAgent';

const style: React.CSSProperties = {
    position: 'fixed',
    top: 75,
    left: 0,
    zIndex: 100,
};

const DeviceInfo: React.FC = () => {
    const { phoneLandscape } = layoutInformation.useState(['phoneLandscape']);
    const handleClickSystemInfo = (): void => {
        const windowOrientation: string | number = window.orientation;
        const screenOrientation: ScreenOrientation = screen.orientation;
        let info: string = 'Device info:\n';
        info += 'window.innerWidth/Height: ' + window.innerWidth + '/' + window.innerHeight + '\n';
        info += 'screen.Width/Height: ' + screen.width + '/' + screen.height + '\n';
        info += 'screen.availWidth/Height: ' + screen.availWidth + '/' + screen.availHeight + '\n';
        info +=
            'safeArea.top/right/bottom/left: ' +
            (safeArea('top', 'top').top as string) +
            '/' +
            (safeArea('right', 'right').right as string) +
            '/' +
            (safeArea('bottom', 'bottom').bottom as string) +
            '/' +
            (safeArea('left', 'left').left as string) +
            '\n';

        info += 'isMobileDevice()?' + isMobileDevice + '\n';
        info += 'isMobileDevice_iOS()?' + ios + '\n';
        info += 'isiPhone?' + ios + '\n';
        info += 'isAndroidPhone?' + android + '\n';
        info += 'isPortrait?' + !phoneLandscape + '\n';
        info += 'isLandscape?' + phoneLandscape + '\n';
        info += 'isPhoneLandscape?' + phoneLandscape + '\n';
        info += 'windowOrientation:' + windowOrientation + '\n';
        info += 'screenOrientation?' + screenOrientation?.angle + '\n';
        info += 'getBoundingClientRect().top: ' + document.documentElement.getBoundingClientRect().top + '\n';
        alert(info);
    };

    return (
        <Button
            onClick={handleClickSystemInfo}
            style={style}
        >
            <PhonelinkSetupIcon style={{ color: '#868686' }} />
        </Button>
    );
};

export default DeviceInfo;
